var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodejs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_5352)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.01 77.3637C128.49 75.9445 131.719 75.9381 134.197 77.3637C146.66 84.4063 159.128 91.4379 171.589 98.4847C173.933 99.805 175.501 102.413 175.477 105.114V147.485C175.495 150.298 173.772 152.968 171.299 154.259C158.876 161.262 146.46 168.275 134.04 175.279C131.509 176.726 128.214 176.614 125.763 175.048C122.038 172.889 118.308 170.741 114.583 168.584C113.822 168.131 112.964 167.769 112.426 167.031C112.902 166.391 113.751 166.311 114.441 166.032C115.996 165.537 117.424 164.744 118.852 163.974C119.213 163.727 119.654 163.821 120 164.043C123.185 165.869 126.341 167.748 129.537 169.556C130.218 169.95 130.909 169.427 131.491 169.102C143.682 162.213 155.887 155.349 168.075 148.457C168.527 148.24 168.777 147.76 168.74 147.266C168.749 133.288 168.742 119.309 168.744 105.331C168.796 104.77 168.471 104.254 167.964 104.024C155.584 97.0526 143.211 90.0702 130.834 83.0967C130.619 82.9493 130.365 82.8702 130.105 82.8698C129.845 82.8694 129.59 82.9478 129.375 83.0946C116.998 90.0702 104.627 97.059 92.2497 104.03C91.7439 104.26 91.4045 104.768 91.4647 105.331C91.4669 119.309 91.4647 133.288 91.4647 147.268C91.4433 147.509 91.4963 147.751 91.6166 147.962C91.737 148.172 91.9189 148.34 92.1379 148.444C95.4408 150.317 98.7481 152.177 102.053 154.044C103.915 155.046 106.201 155.641 108.253 154.873C110.063 154.224 111.332 152.377 111.297 150.455C111.315 136.559 111.289 122.661 111.31 108.768C111.265 108.151 111.85 107.641 112.45 107.699C114.037 107.688 115.626 107.678 117.213 107.703C117.876 107.688 118.332 108.353 118.25 108.974C118.243 122.958 118.267 136.942 118.239 150.925C118.243 154.652 116.712 158.707 113.265 160.531C109.018 162.731 103.769 162.264 99.5736 160.155C95.9416 158.342 92.4755 156.203 88.9079 154.26C86.4287 152.977 84.7145 150.296 84.732 147.485V105.114C84.706 102.358 86.3361 99.7017 88.753 98.4007C101.173 91.3912 113.592 84.3764 126.01 77.3637Z",
    fill: "#8CC84B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.846 106.714C142.263 106.366 148.062 106.508 152.937 109.176C156.711 111.221 158.803 115.513 158.87 119.706C158.765 120.272 158.173 120.584 157.633 120.545C156.062 120.543 154.49 120.567 152.918 120.534C152.251 120.56 151.864 119.945 151.78 119.356C151.328 117.35 150.234 115.363 148.346 114.395C145.447 112.944 142.086 113.017 138.925 113.047C136.618 113.17 134.137 113.369 132.182 114.726C130.681 115.754 130.225 117.829 130.761 119.5C131.266 120.7 132.651 121.087 133.784 121.444C140.312 123.151 147.23 122.982 153.634 125.229C156.285 126.145 158.879 127.925 159.786 130.701C160.973 134.422 160.453 138.869 157.806 141.855C155.659 144.313 152.533 145.651 149.415 146.377C145.267 147.302 140.962 147.326 136.749 146.915C132.788 146.464 128.666 145.423 125.608 142.724C122.993 140.453 121.716 136.916 121.843 133.501C121.873 132.925 122.447 132.523 123 132.57C124.582 132.557 126.165 132.553 127.748 132.572C128.38 132.527 128.849 133.073 128.881 133.669C129.173 135.581 129.892 137.587 131.558 138.72C134.775 140.795 138.811 140.653 142.495 140.711C145.546 140.576 148.972 140.535 151.462 138.518C152.776 137.368 153.165 135.443 152.81 133.787C152.425 132.389 150.963 131.738 149.707 131.312C143.263 129.273 136.267 130.013 129.885 127.708C127.294 126.792 124.789 125.061 123.793 122.399C122.404 118.632 123.041 113.972 125.965 111.086C128.816 108.215 132.932 107.11 136.846 106.714V106.714Z",
    fill: "#8CC84B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_5352",
    x: 0,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_5352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_5352",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.fedd77d10eea0f351c2a6a59374f971c.svg";
export { ForwardRef as ReactComponent };